import { render, staticRenderFns } from "./ModalLab.vue?vue&type=template&id=2efd559e&scoped=true&lang=pug"
import script from "./ModalLab.vue?vue&type=script&lang=js"
export * from "./ModalLab.vue?vue&type=script&lang=js"
import style0 from "./ModalLab.vue?vue&type=style&index=0&id=2efd559e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd559e",
  null
  
)

export default component.exports